import React, { useEffect, useState } from 'react';
import { Container, Image } from 'react-bootstrap';
import RoundButton from '../../common/RoundButton';
import { HiDotsHorizontal } from '@react-icons/all-files/hi/HiDotsHorizontal';
import { useAuth } from '../../auth/Auth';
import { useHistory } from 'react-router-dom';
import { myRoomViewModel } from './my.room.viewmodel';
import { isStrNullOrEmpty } from '../../../utils/utils';
import ReactTimeAgo from 'react-time-ago';
import ShareModal from '../../common/ShareModal';
import Binky from '../../common/Binky';
import CampHeader from '../../header/CampHeader';
import CampHeaderGuest from '../../header/CampHeaderGuest';
import { getUserProfileUrl } from '../../../utils/camp.utils';
import VerifiedBadge from '../../../assets/icon/Verified-badge.svg';
import PartnerHeader from '../school/PartnerHeader';
import { feedViewModel } from '../feed/feed.view.model';
import Fullview from '../../common/Fullview';
import prev from '../../../assets/icon/prev.svg';
import next from '../../../assets/icon/next.svg';
import { useLocation } from 'react-router-dom';
import OptimizeSignup from '../onboarding/signup_popups/OptimizeSignup';

const ShareCreation = () => {
    const _PAGE_LIMIT = 10;
    const location = useLocation();
    const myParam = new URLSearchParams(location.search).get('encrypt');
    const history = useHistory();
    const decryptedData = JSON.parse(atob(myParam))
    let creation_id = decryptedData.id;
    const { dependent, school, partner, guardian, fetchAPI } = useAuth();
    const [isLoding, setIsLoading] = useState(true);
    const [creation, setCreation] = useState(null);
    const [feedList, setFeedList] = useState([]);
    const [creationDate, setCreationDate] = useState();
    const [favorites, setFavorites] = useState([]);
    const [showShareModal, setShowShareModal] = useState(false);
    const [showGuestRedirectModal, setShowGuestRedirectModal] = useState(false);
    const [showFullview, setShowFullview] = useState(false);
    const [fullviewData, setFullviewData] = useState({});
    const [commentList, setCommentList] = useState([]);
    const defaultValue = {
        prevShow: 'hide',
        prevIndex: 0,
        nextShow: 'hide',
        nextIndex: 1,
        currentIndex: 0,
    };
    const [navigation, setNavigation] = useState(defaultValue);
    const handleNavigation = (e) => {
        const idx = parseInt(e.currentTarget.value, 10);
        let prevIndex;
        let prevShow;
        let nextIndex;
        let nextShow;
        if (idx === 0) {
            prevIndex = idx;
            prevShow = 'hide';
        } else {
            prevIndex = idx - 1;
            prevShow = 'show';
        }
        if (idx === creation.media.length - 1) {
            nextIndex = idx;
            nextShow = 'hide';
        } else {
            nextIndex = idx + 1;
            nextShow = 'show';
        }
        setNavigation((navigation) => ({
            ...navigation,
            currentIndex: idx,
            prevIndex: prevIndex,
            prevShow: prevShow,
            nextIndex: nextIndex,
            nextShow: nextShow,
        }));
    };
    const handleCloseFullview = () => {
        setShowFullview(false);
    };
    const handleShowFullview = () => {
        setShowFullview(true);
        // handleScroll();
    };
    let count = 0;
    const [query, setQuery] = useState({
        limit: _PAGE_LIMIT,
        has_more: true,
    });

    const makeFavorites = (favorite) => {
        if (count !== 0) {
            if (!isStrNullOrEmpty(favorite)) {
                setFavorites(favorites => [...favorites, ' · '])
                setFavorites(favorites => [...favorites, favorite])
            }
        } else {
            if (!isStrNullOrEmpty(favorite)) {
                setFavorites(favorites => [...favorites, favorite])
                count = count + 1;
            }
        }
    };



    const handleBinky = (creationId, binkyId, binkyCount) => {
        if (!dependent) {
            setShowGuestRedirectModal(true);
            localStorage.setItem('kids_login_location', window.location.href)
        }
        if (!dependent.profile.is_activated) {
            return setShowGetVerifiedModal(true)
        }
        // update feed list
        const newFeedList = feedList.map((obj) => {
            return {
                ...obj,
                binky_count: binkyCount,
                binky_id: binkyId,
            };
        });
        setFeedList(newFeedList);
    }

    const handleComment = (creationId, commentCount) => {
        if (!dependent) {
            setShowGuestRedirectModal(true);
            localStorage.setItem('kids_login_location', window.location.href)
        }
        if (!dependent.profile.is_activated) {
            return setShowGetVerifiedModal(true)
        }
        // update feed list
        const newFeedList = feedList.map((obj) => {
            return {
                ...obj,
                comment_count: commentCount
            };
        });
        setFeedList(newFeedList);
    }

    useEffect(() => {
        const getFeed = async () => {
            try {
                const res = await myRoomViewModel.getCreationById(creation_id);
                setCreation(res.data);
                setFeedList([res.data])
                res.data.user.profile.favorites.map(makeFavorites)
                setCreationDate(res.data.created_at);
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching creation data:', error);
            }
        };
        getFeed();
    }, [])



    useEffect(() => {
        if (creation) {
            const isOnlyOne = creation.media.length === 1;
            if (!isOnlyOne && navigation.currentIndex === 0) {
                setNavigation((navigation) => ({
                    ...navigation,
                    nextShow: 'show',
                }));
            }
            setTimeout(() => {
              const logData = {
                creation_id: creation?.id,
              };
              try {
                feedViewModel.addCreationView(logData);
              } catch (error) {
                console.log(error);
              }
            }, 3000);
        } else {
            setNavigation(defaultValue);
        }
    }, [creation])

    const onProfileClick = () => {
        history.push(`/${creation.user.username}`)
    }

    const getComments = () => {
        feedViewModel.commentList({ creation_id: creation_id })
            .then((res) => {
                setCommentList([...res.data]);
            })
            .catch();
    }

    const showFullviewHandler = () => {
        if (dependent && !guardian) {
            if (!dependent.profile.is_activated) {
                return setShowGetVerifiedModal(true)
            }
            const data = {
                id: creation.id,
                user: creation.user,
                media: creation.media,
                title: creation.title,
                description: creation.description,
                created_at: creation.created_at,
                binky_id: creation.binky_id,
                binky_count: creation.binky_count,
                comment_count: creation.comment_count,
                challengeId: creation.challenge.id,
                challenge_id: creation.challenge !== '' ? creation.challenge.id : '',
                challenge_title:
                    creation.challenge !== '' ? creation.challenge.title : '',
                // creation.challenge !== '' ? "creation.challenge.title" : '',
            };
            setFullviewData(data);
            // setFullviewBinky(binky);
            handleShowFullview();
            getComments();
        } else {
            setShowGuestRedirectModal(true);
            localStorage.setItem('kids_login_location', window.location.href)
        }
    };

    return (
        !isLoding ?
            <div className='share_creation_wrapper' id='share-creation'>
                {/* {creation?.id && <CreationMeta creation={creation} />} */}
                <OptimizeSignup showModal={showGuestRedirectModal} setShowModal={setShowGuestRedirectModal} />
                {dependent ?
                    <CampHeader /> : school || partner ? <PartnerHeader /> : <CampHeaderGuest />
                }
                <Container>
                    <div className='share_creation_inner'>
                        <div className='image-wrapper'>
                            <div className="fv-header">
                                <div className="avatar-wrapper" onClick={onProfileClick} role="button">
                                    <div className="full-small-type">
                                        <div className="avatar-image">
                                            {creation ?
                                                <Image src={
                                                    creation.user.profile.picture_url ?
                                                        creation.user.profile.picture_url :
                                                        getUserProfileUrl(creation.user)
                                                }
                                                    className="rounded-circle" />
                                                :
                                                <Image src="../../../assets/profile/default-profile-rooty.svg" className="rounded-circle" />
                                            }
                                            <span className='verified-badge'>
                                                <Image
                                                    className={`rounded-circle dashboard-kid-avatar`}
                                                    src={VerifiedBadge}
                                                /></span>
                                        </div>
                                        <div className="user-info">
                                            <div className="user-name">
                                                <div className="nickname">{creation && creation.user.username}</div>
                                                <div className="groupname"><span></span></div>
                                            </div>
                                            <div className="favorites">{favorites && favorites}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="last-column" onClick={() => setShowShareModal(true)} role="button">
                                    <HiDotsHorizontal />
                                </div>
                            </div>
                            <div className="fv-content">
                                {creation.media.map((image, key) => {
                                    const totalImageCount = creation.media.length;
                                    const imageShow =
                                        key === navigation.currentIndex ? 'show' : 'hide';
                                    const displayNumbering =
                                        totalImageCount > 1 ? (
                                            <div className="fv-numbering">
                                                {key + 1} / {totalImageCount}
                                            </div>
                                        ) : (
                                            ''
                                        );
                                    const binky =
                                        creation.binky_count === undefined ? (
                                            <></>
                                        ) : (
                                            <Binky
                                                feedList={feedList}
                                                creationId={creation.id}
                                                binkyCountProp={creation.binky_count}
                                                binkyIdProp={creation.binky_id}
                                                commentCountProp={creation.comment_count}
                                                isShareCreation={true}
                                                handleBinky={handleBinky}
                                                setShowFullview={showFullviewHandler}
                                            />
                                        );
                                    return (
                                        <div key={key} className={`fv-image-container ${imageShow}`}>
                                            <img className={`fv-creation`} src={image.url} />
                                            {binky}
                                            {displayNumbering}
                                            <button
                                                className={`prev-button ${navigation.prevShow}`}
                                                value={navigation.prevIndex}
                                                onClickCapture={handleNavigation}
                                            >
                                                <img src={prev} value={navigation.prevIndex} />
                                            </button>
                                            <button
                                                className={`next-button ${navigation.nextShow}`}
                                                value={navigation.nextIndex}
                                                onClickCapture={handleNavigation}
                                            >
                                                <img src={next} value={navigation.prevIndex} />
                                            </button>
                                        </div>
                                    );
                                })}
                                <div className="feed-title-bar">
                                    <div className="fv-title">{creation && creation.title}</div>
                                    {creationDate ?
                                        <div className="fv-created">
                                            <ReactTimeAgo date={creationDate} timeStyle="twitter" />
                                        </div> : ""
                                    }
                                </div>
                            </div>
                        </div>
                        {!dependent && !guardian && !school && !partner ?
                            <div className='share_creation_content' style={{paddingBottom: '60px'}}>
                                <h1>TaleTree, The Global Community of Creative & Kind Kids.</h1>
                                <p>Empower kids to develop confidence and social, emotional skills through creative exploration!</p>
                                <div className="btn-wrapper" onClick={() => history.push("/")}>
                                    <RoundButton
                                        type="button"
                                        label="Join TaleTree now!"
                                        className="gred-btn"
                                    />
                                </div>
                            </div>
                            : <div className='share_creation_content'></div>}
                    </div>
                </Container>
                <Fullview
                    show={showFullview}
                    setShowFullview={setShowFullview}
                    data={fullviewData}
                    handleClose={handleCloseFullview}
                    feedList={feedList}
                    handleBinky={handleBinky}
                    handleComment={handleComment}
                    commentList={commentList}
                    getComments={getComments}
                    isFullView={true}
                />
                <ShareModal
                    showShareModal={showShareModal}
                    setShowShareModal={setShowShareModal}
                    shareModalProps={creation}
                />
            </div>
            : ""
    )
}

export default ShareCreation;